import React, { useState, useEffect } from 'react';
import { Box, DialogContent, useMediaQuery } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from 'lodash';
import momenttz from "moment-timezone";
import moment from "moment"
import BaseModal from '../../../../UserScreen/InventoryPage/InventorySettings/components/BaseModal/BaseModal';
import SidebarTabs from '../../../../UserScreen/InventoryPage/InventorySettings/components/SidebarTabs/SidebarTabs';
import { useTheme } from '@mui/material/styles';
import ModalFooter from '../../../../UserScreen/InventoryPage/InventorySettings/components/ModalFooter/ModalFooter';
import TemplateInfo from '../TemplateInfo';
import QuotaActions from './QuotaActions';
import Notifications from './Notifications';
import { createParentPool, updateParentPool, ACTION_TYPES } from '../../slice';
import { toast } from 'react-toastify';

const CreateServiceAccountPopup: React.FC<any> = ({ open, onClose, authReducer, selectedAccount, accountCredential, createParentPool, updateParentPool, updateParentPoolData, createParentPoolData, accountDp, editRow }) => {
    const dispatch = useDispatch();
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [refreshIconClicked, setRefreshIconClicked] = useState(true);
    const [planPoolToggle, setPlanPoolToggle] = useState("standard")
    const handlePlanPoolToggle = (val) => { setPlanPoolToggle(val) }
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [entries, setEntries] = useState<any>([{ usagePercentage: '70', type: 'sendNotification' }]);
    const [emailInput, setEmailInput] = useState('');
    const [emails, setEmails] = useState<any>([]);
    const [error, setError] = useState('');
    const tabs = ['Details', 'Quota Kontrol', 'Notifications'];
    const isEditMode = !!editRow?.id;

    const [formData, setFormData] = useState<any>({
        poolName: '',
        poolSize: '',
        poolUnit: 'tb',
        startDate: null,
        endDate: null,
        isRecurring: true,
        poolInfo: ''
    });

    const clearData = () => {
        setEmails([])
        setActiveTabIndex(0)
        setEntries([{ usagePercentage: '70', type: 'sendNotification' }])
        setFormData({
            poolName: '',
            poolSize: '',
            poolUnit: 'tb',
            startDate: null,
            endDate: null,
            isRecurring: true,
            poolInfo: ''
        })
    }

    const handleTabChange = (_: string, index: number, profileId?: string) => { setActiveTabIndex(index); };

    const getFirstDayOfMonth = () => { return momenttz().utc().startOf('month').hours(0).minutes(0).seconds(0).milliseconds(0); };

    const handleSave = () => {
        if (activeTabIndex === 2) {
            if (emailInput.trim() !== "") {
                setError("Press Enter to add the email .");
                return;
            }
            if(selectedAccount?.isPooledAccount){
                handleUpdatePool()
            } else{ handleCreateAccount() }
        } else {
            if (planPoolToggle === 'pooled') { setActiveTabIndex(activeTabIndex + 1) }
        }
    };

    const isTemplateInfoValid = () => {
        const { poolInfo, poolSize, startDate, endDate } = formData;
        return (!!poolInfo?.trim() && !!poolSize && !!startDate && formData.poolSize > 0 && planPoolToggle !== 'standard');
    };

    const handleCancel = () => {
        if (activeTabIndex === 0) { onClose(false); setActiveTabIndex(0) } else { setActiveTabIndex(activeTabIndex - 1) }
    };

    const handleInputChange = (field, value) => {
        setFormData(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    useEffect(() => {
            clearData()
             setPlanPoolToggle(selectedAccount?.isPooledAccount ? "pooled": "standard")
            if (selectedAccount?.isPooledAccount) {
                setFormData({
                    poolName: selectedAccount?.accountName,
                    poolSize: selectedAccount?.poolSize,
                    poolUnit: selectedAccount?.unit,
                    startDate: moment(selectedAccount?.startDate),
                    endDate: moment(selectedAccount?.endDate),
                    isRecurring: selectedAccount?.isRecurring,
                    poolInfo: selectedAccount?.poolInfo
                })
                setEmails(selectedAccount?.quota?.usersToNotify)
                setEntries(selectedAccount?.quota?.quotaActions?.map((q) => { return { usagePercentage: q?.usagePercentage, type: q?.type } }))
            }
    
        }, [selectedAccount, open])

    const renderTabContent = (index: number): JSX.Element | null => {
        switch (index) {
            case 0:
                return <TemplateInfo isEditMode={isEditMode} selectedAccount={selectedAccount} planPoolToggle={planPoolToggle} handlePlanPoolToggle={handlePlanPoolToggle} currentSubPool={formData} handleSubPoolChange={handleInputChange} />
            case 1:
                return <QuotaActions entries={entries} handleValueChange={handleValueChange} handleRemoveEntry={handleRemoveEntry} handleAddEntry={handleAddEntry} />
            case 2:
                return <Notifications emails={emails} handleDeleteEmail={handleDeleteEmail} error={error} setError={setError} emailInput={emailInput} setEmailInput={setEmailInput} handleAddEmail={handleAddEmail} />
            default:
                return null;
        }
    };

    const handleTabChanges = (_: any, index: number) => { handleTabChange(tabs[index], index); };

    const handleValueChange = (index, field, value) => {
        const newEntries = [...entries];
        newEntries[index][field] = value;
        setEntries(newEntries);
    };

    const handleAddEntry = () => {
        setEntries([...entries, { usagePercentage: '100', type: 'sendNotification' }]);
    };

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const handleCreateAccount = () => {
        let params = {
            dpId: selectedAccount ? selectedAccount?.dpId : "",
            accountNumber: selectedAccount?.accountNumber,
            credentialId: selectedAccount ? selectedAccount?.credentialId : "" ,
            poolName: selectedAccount?.accountName,
            poolSize: formData?.poolSize,
            unit: formData?.poolUnit,
            startDate: formData?.startDate,
            endDate: formData?.endDate,
            isRecurring: formData?.isRecurring,
            poolInfo: formData?.poolInfo,
            notificationMethods: ["email"],
            quotaActions: entries,
            usersToNotify: emails
        }
        createParentPool(params);
    }

   const handleUpdatePool = async () => {
        let params = {
            parentPoolId: selectedAccount?.parentPoolId,
            dpId: selectedAccount ? selectedAccount?.dpId : "",
            accountNumber: selectedAccount?.accountNumber,
            credentialId: selectedAccount ? selectedAccount?.credentialId : "" ,
            poolName: selectedAccount?.accountName,
            poolSize: formData?.poolSize,
            unit: formData?.poolUnit,
            startDate: formData?.startDate,
            endDate: formData?.endDate,
            isRecurring: formData?.isRecurring,
            poolInfo: formData?.poolInfo,
            notificationMethods: ["email"],
            quotaActions: entries,
            usersToNotify: emails
        }
         updateParentPool(params);
    }

    useEffect(() => {
        if (!_.isEmpty(createParentPoolData)) {
            toast.success(`${selectedAccount?.accountName} created successfully`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setActiveTabIndex(0)
            dispatch({ type: ACTION_TYPES.CREATE_PARENT_POOL, payload: [] })
            onClose(true);
            clearData()
        }

    }, [createParentPoolData])

     useEffect(() => {
        if (!_.isEmpty(updateParentPoolData)) {
            toast.success(`${selectedAccount?.accountName} updated successfully`, {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            setActiveTabIndex(0)
            dispatch({ type: ACTION_TYPES.UPDATE_PARENT_POOL, payload: [] })
            onClose(true);
            clearData()
        }

    }, [updateParentPoolData])

    const handleAddEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && emailInput) {
            event.preventDefault();
            if (validateEmail(emailInput)) {
                setEmails([...emails, { name: emailInput.split('@')[0].replace('.', ' ').replace(/\b\w/g, char => char.toUpperCase()), email: emailInput }]);
                setEmailInput('');
                setError('');
            } else {
                setError('Invalid email address');
            }
        }
    };

    const handleRemoveEntry = (index) => {
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
    };

    const handleDeleteEmail = (emailToDelete: string) => {
        setEmails(emails.filter(email => email !== emailToDelete));
    };


    return (
        <>
            <BaseModal showOnlineOffline={false} width='850px' height="540px" open={open} onClose={() => { onClose(false); }} title={`${isEditMode ? 'Account Definition' : 'Edit Account Info'} `} showOnlineStatus={false}  showRefreshIcon={false} setRefreshIconClicked={setRefreshIconClicked}>
                <DialogContent className="modal-content-wrapper">
                    <Box
                        className="modal-body"
                        style={{ flexDirection: isSmallScreen ? 'column' : 'row' }}
                    >
                        <SidebarTabs
                            tabs={tabs}
                            activeTab={activeTabIndex}
                            onChange={handleTabChanges}
                            isHorizontal={isSmallScreen}
                            disabledTabs={planPoolToggle === 'standard' ? [1, 2] : []}
                        />
                        <Box className="modal-content">
                            <Box className="modal-tab-panel-starlink">{renderTabContent(activeTabIndex)}</Box>
                            {<ModalFooter
                                onClose={handleCancel}
                                onSave={handleSave}
                                cancelText={"Cancel"}
                                saveText={activeTabIndex === 2 ? "Save" : "Next"}
                                disableSave={activeTabIndex === 0 ? !isTemplateInfoValid() : activeTabIndex === 2 ?  (entries?.length > 0 ? emails?.length > 0 ? false : true : false)   : false}
                            />}
                        </Box>
                    </Box>
                </DialogContent>
            </BaseModal>
        </>
    );
};

const mapStateToProps = (state) => ({
    selectedOu: state.authReducer.selectedOu,
    createParentPoolData: state.starlinkAdmin.createParentPoolData,
    updateParentPoolData: state.starlinkAdmin.updateParentPoolData,
});

export default withRouter(
    connect(mapStateToProps, { createParentPool, updateParentPool })(CreateServiceAccountPopup))